import readLengthPlotcfDNA from "../../../../content/posts/data-release-notes/cliveome_2022.05/read_length.jsx";
import accuracyPlotcfDNA from "../../../../content/posts/data-release-notes/cliveome_2022.05/accuracy.jsx";
import * as React from 'react';
export default {
  readLengthPlotcfDNA,
  accuracyPlotcfDNA,
  React
};